/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).on("change", ".add__select_custom", function () {
  $(this).hide();
  $(this).parent().find(".add__custom_loader").show();
  var vid = $(this).val();
  $(this).val("");
  data = {
    id: vid,
    quantity: 1,
  };

  jQuery.ajax({
    type: "POST",
    url: "".concat(window.routes.cartAddUrl, ".js"),
    data: data,
    dataType: "json",
    error: function () {
      $("#error_addtocart").show().delay(3000).fadeOut();
    },
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: vid,
            quantity: 1,
          },
        })
      );
      if (jQuery(".goal-price").length != 0) {
        var goalAmount = jQuery(".goal-price").attr("data-goal") / 100;
        var subTotal =
          jQuery(".PriceTotal").find(".price-subtotal").attr("data-subtotal") /
          100;
        var percentage_reached = (eval(subTotal) / eval(goalAmount)) * 100;
        if (parseFloat(percentage_reached) > 100) {
          var percentage_reached = 100;
        }
      } else {
        var percentage_reached = 100;
      }
      jQuery(".goal-progress-fill").css(
        "width",
        Math.round(percentage_reached) + "%"
      );
    },
  });

  setTimeout(function () {
    $(".add__select_custom").show();
    $(".add__custom_loader").hide();
  }, 1550);
});

function addToCart(variant_id) {
  data = {
    id: variant_id,
    quantity: 1,
  };

  jQuery.ajax({
    type: "POST",
    url: "".concat(window.routes.cartAddUrl, ".js"),
    data: data,
    dataType: "json",
    error: function () {
      $("#error_addtocart").show().delay(3000).fadeOut();
    },
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true, //this code is for prestige theme, is to refresh the cart
        })
      );
      if (jQuery(".goal-price").length != 0) {
        var goalAmount = jQuery(".goal-price").attr("data-goal") / 100;
        var subTotal =
          jQuery(".PriceTotal").find(".price-subtotal").attr("data-subtotal") /
          100;
        var percentage_reached = (eval(subTotal) / eval(goalAmount)) * 100;
        if (parseFloat(percentage_reached) > 100) {
          var percentage_reached = 100;
        }
      } else {
        var percentage_reached = 100;
      }
      jQuery(".goal-progress-fill").css(
        "width",
        Math.round(percentage_reached) + "%"
      );
    },
  });

  jQuery(".ProductItem__Variants").removeClass("ProductItem__Variants_show");
  jQuery("body").removeClass("product-varint-modal-open");
}

// cart drawer goal start
jQuery(window).bind("load", function () {
  setInterval(function () {
    if (jQuery(".goal-price").length != 0) {
      var goalAmount = jQuery(".goal-price").attr("data-goal") / 100;
      var subTotal =
        jQuery(".PriceTotal").find(".price-subtotal").attr("data-subtotal") /
        100;
      var percentage_reached = (eval(subTotal) / eval(goalAmount)) * 100;
      if (parseFloat(percentage_reached) > 100) {
        var percentage_reached = 100;
      }
    } else {
      var percentage_reached = 100;
    }
    jQuery(".goal-progress-fill").css(
      "width",
      Math.round(percentage_reached) + "%"
    );
  }, 10);
});
jQuery(document).on("click", ".CartItem__Remove", function () {
  setInterval(function () {
    if (jQuery(".goal-price").length != 0) {
      var goalAmount = jQuery(".goal-price").attr("data-goal") / 100;
      var subTotal =
        jQuery(".PriceTotal").find(".price-subtotal").attr("data-subtotal") /
        100;
      var percentage_reached = (eval(subTotal) / eval(goalAmount)) * 100;
      if (parseFloat(percentage_reached) > 100) {
        var percentage_reached = 100;
      }
    } else {
      var percentage_reached = 100;
    }
    jQuery(".goal-progress-fill").css(
      "width",
      Math.round(percentage_reached) + "%"
    );
  }, 100);
});
// cart drawer goal end

/* cart drawer upsell :: start */
var drawerInterval = "";
jQuery(document).ready(function () {
  drawerInterval = setInterval(function () {
    if (jQuery("#sidebar-cart").attr("aria-hidden") == "false") {
      //console.log("==>", jQuery(".cart_upsell_box").attr("style"));
      //if(jQuery('.cart_upsell_box').css('display')=='block' || jQuery('.cart_upsell_box').css('display')==undefined){
      var upsellCount = jQuery(".custom--upsell-inner").find(
        ".upsell--item"
      ).length;
      //console.log("upsellCount-->", upsellCount);
      var displayUpsell = 0;
      jQuery(".custom--upsell-inner")
        .find(".upsell--item")
        .each(function () {
          if (jQuery(this).css("display") == "none") {
            displayUpsell++;
          }
        });
      //console.log("displayUpsell-->", displayUpsell);
      if (displayUpsell == upsellCount) {
        jQuery(".cart_upsell_box").addClass("upsell-full");
        jQuery(".cart_upsell_box").hide();
      } else {
        jQuery(".cart_upsell_box").removeClass("upsell-full");
        jQuery(".cart_upsell_box").show();
      }
      //}
    }
  }, 1000);
});

jQuery(document).on("change", ".add__btn_custom_sel", function () {
  //$(".add__btn_custom_sel").change(function () {
  $(this).hide();
  $(this).parent().find(".add__custom_loader").show();
  var vid = $(this).val();
  $(this).val("");
  data = {
    id: vid,
    quantity: 1,
  };

  jQuery.ajax({
    type: "POST",
    url: "".concat(window.routes.cartAddUrl, ".js"),
    data: data,
    dataType: "json",
    error: function () {
      $("#error_addtocart").show().delay(3000).fadeOut();
    },
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: vid,
            quantity: 1,
          },
        })
      );
      if (jQuery(".goal-price").length != 0) {
        var goalAmount = jQuery(".goal-price").attr("data-goal") / 100;
        var subTotal =
          jQuery(".PriceTotal").find(".price-subtotal").attr("data-subtotal") /
          100;
        var percentage_reached = (eval(subTotal) / eval(goalAmount)) * 100;
        if (parseFloat(percentage_reached) > 100) {
          var percentage_reached = 100;
        }
      } else {
        var percentage_reached = 100;
      }
      jQuery(".goal-progress-fill").css(
        "width",
        Math.round(percentage_reached) + "%"
      );
    },
  });

  setTimeout(function () {
    $(".add__btn_custom_sel").show();
    $(".add__custom_loader").hide();
  }, 1550);
});

jQuery(document).on("change", ".variant-popdown-upsell-select", function () {
  //$(".variant-popdown-upsell-select").change(function(){
  var vid = $(this).val();
  $(this)
    .parent()
    .parent()
    .parent()
    .parent()
    .find(".upsell-item-add-button")
    .find(".upsell-add-button-cart")
    .attr("data-vid", vid);
});

jQuery(document).on("click", ".upsell-add-button-cart", function () {
  //$(".upsell-add-button-cart").click(function () {
  var vid = $(this).attr("data-vid");
  $(this).find(".btn__text").hide();
  $(this).find(".add__custom_loader").show();
  data = {
    id: vid,
    quantity: 1,
  };

  jQuery.ajax({
    type: "POST",
    url: "".concat(window.routes.cartAddUrl, ".js"),
    data: data,
    dataType: "json",
    error: function () {
      $("#error_addtocart").show().delay(3000).fadeOut();
    },
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: vid,
            quantity: 1,
          },
        })
      );
      if (jQuery(".goal-price").length != 0) {
        var goalAmount = jQuery(".goal-price").attr("data-goal") / 100;
        var subTotal =
          jQuery(".PriceTotal").find(".price-subtotal").attr("data-subtotal") /
          100;
        var percentage_reached = (eval(subTotal) / eval(goalAmount)) * 100;
        if (parseFloat(percentage_reached) > 100) {
          var percentage_reached = 100;
        }
      } else {
        var percentage_reached = 100;
      }
      jQuery(".goal-progress-fill").css(
        "width",
        Math.round(percentage_reached) + "%"
      );
    },
  });

  setTimeout(function () {
    $(this).find(".btn__text").show();
    $(this).find(".add__custom_loader").hide();
  }, 1550);
});
/* cart drawer upsell :: end */

/* get filter count data and set filter drawer start js */
function filterCountData(){
  if(jQuery('#collection-filter-drawer').hasClass('filter__drawer')) {
    var countoldFilter = jQuery('.CollectionMain').find('.ProductListWrapper').attr('data-fitler-count');
    var setCountId = setInterval(function(){
      var countnewFilter = jQuery('.CollectionMain').find('.ProductListWrapper').attr('data-fitler-count');
      // console.log("countnewFilter",countnewFilter,countoldFilter);
      if(countoldFilter!=countnewFilter){
        jQuery('#collection-filter-drawer').find('.Drawer__Title.Drawer__Title_new').find('.count-collection').text(countnewFilter);
        clearInterval(setCountId);
      }
    },1000);
  }
}
/* get filter count data and set filter drawer end js */

jQuery(document).on("click",".CollectionFilters__ClearButton",function(){
  filterCountData();
  jQuery('.CollectionFilters').find('.Drawer__Close').trigger("click");
});

/* load more product start code here */
jQuery(document).ready(function () {
  let page = 2;
  let loading = false;
  let totalHeightminus = 1000;
  let totalPerPage = jQuery("#per_page_collection").val();
  let totalCollectionProduct = jQuery("#collection_total_products").val();
  let totalPage = Math.ceil(totalCollectionProduct / totalPerPage);
  let collectionUrl = jQuery("#collection_url").val();
  if (
    totalPerPage != "" &&
    totalPerPage != undefined &&
    jQuery("#load-more-btn-wrapper").length != 0
  ) {
    $(window).scroll(function () {
      var loadMoreThreshold = Math.round(
        jQuery("#more-products").find(".Grid__Cell").last().offset().top
      ); // Adjust this value based on your preference
      var finalHeight = loadMoreThreshold - totalHeightminus;
      if (!loading && $(window).scrollTop() > finalHeight) {
        loadMore();
      }
    });
    function loadMore() {
      if (!loading) {
        loading = true;
        if(totalPage >= page) {
         if(window.innerWidth <= 768) {
           var layoutType = jQuery('.collection__filter_control').find('.CollectionToolbar__LayoutSwitch').find('.CollectionToolbar__LayoutType.is-active').attr('data-grid-type');
           var newCount = jQuery('.collection__filter_control').find('.CollectionToolbar__LayoutSwitch').find('.CollectionToolbar__LayoutType.is-active').attr('data-count');
          }else{
            var layoutType = jQuery('.collection__filter_control').find('.CollectionToolbar__LayoutSwitch').eq(1).find('.CollectionToolbar__LayoutType.is-active').attr('data-grid-type');
           var newCount = jQuery('.collection__filter_control').find('.CollectionToolbar__LayoutSwitch').eq(1).find('.CollectionToolbar__LayoutType.is-active').attr('data-count');
          }
          // Prepare the body parameter for API or server-side use
          var body = JSON.stringify({
            attributes: {
              ["collection_" + layoutType + "_items_per_row"]: newCount,
            },
          });
          var productList = jQuery('.CollectionMain').find(".ProductList");
          if (productList) {
            var previousCount = parseInt(productList.attr("data-".concat(layoutType, "-count")));
    
            if (previousCount === newCount) {
              return; // Nothing has changed so we just return to avoid reflow
            }
    
            productList.attr(
              "data-".concat(layoutType, "-count"),
              newCount
            );
          }
          var url = window.location.origin + "/" + collectionUrl + "?page=" + page;
          //added for filter data for query string with filter start
          var queryString = window.location.search; // Includes the '?' at the start
          if(queryString!=""){
            var rawQueryString = queryString.substring(1);
            url = window.location.origin + "/" + collectionUrl + "?page=" + page+'&'+rawQueryString;
          }
          jQuery("#load-more-btn-wrapper").show();
          //added for filter data for query string with filter end
          $.get(url, function (data) {
            var newProducts = $(data).find(".ProductList--grid").html();
            if (newProducts.trim().length > 0) {
              $("#more-products").append(newProducts);
              //jQuery('.CollectionMain').find(".ProductList").attr("data-".concat(layoutType, "-count"),newCount);
              var settingdrawer = JSON.parse(jQuery('#sidebar-cart').attr("data-section-settings")); // Create the popover if available
              jQuery('.CollectionMain').find(".ProductList").find(".Grid__Cell").each(function () {
                var $item = $(this); // Wrap the current item in jQuery
                var classgridin="product_solout";
                if(jQuery(this).hasClass('product_active')){
                  classgridin="product_active";
                }
                $item.attr("class", function () {
                  return "Grid__Cell "+classgridin; // Retain only the 'Grid__Cell' class
                });
              
                if (layoutType === "mobile") {
                  $item.addClass(`1/${newCount}--phone`);
                } else {
                  var previousTabletCount = previousCount === 2 ? 2 : 3;
                  var newTabletCount = newCount === 2 ? 2 : 3;
              
                  //if (settingdrawer["filterPosition"] === "drawer") {
                    $item.addClass(`1/${newCount}--lap-and-up`);
                  //} else {
                    $item.addClass(`1/${newCount}--desk`);
                  //}
              
                  $item.addClass(`1/${newTabletCount}--tablet-and-up`);
                }
              });
              // Force lazy sizes to recalculate item sizes
              page++; // Increment page only if new products are loaded
              loading = false;
              window.handleMobileBehavior();
            }else{
              loading = true;
              jQuery("#load-more-btn-wrapper").hide();
            }
            
          }).fail(function () {
            //jQuery("#load-more-btn-wrapper").hide();
            loading = false; // Reset loading flag in case of failure
          });
        } else {
          loading = true;
          jQuery("#load-more-btn-wrapper").hide();
        }
      }
    }
  }
});

/* load more code end here */

jQuery(document).on("click", ".plus_button_variant", function () {
  var $currentQuickAdd = jQuery(this)
    .closest(".ProductItem-quicv4")
    .find(".prductitem-quickadd > .ProductItem__Variants");

  if (jQuery(this).hasClass("rotate")) {
    $currentQuickAdd.removeClass("flex");
    jQuery(this).removeClass("rotate");
  } else {
    jQuery(
      ".ProductItem-quicv4 .prductitem-quickadd > .ProductItem__Variants"
    ).removeClass("flex");
    jQuery(
      ".ProductItem-quicv4 .prductitem-quickadd > .plus_button_variant"
    ).removeClass("rotate");

    $currentQuickAdd.addClass("flex");
    jQuery(this).addClass("rotate");
  }
});

jQuery(document).on("click", ".show_variant_plus", function () {
  jQuery(".ProductItem__Variants").removeClass("ProductItem__Variants_show");
  jQuery(this)
    .parent()
    .parent()
    .find(".ProductItem__Variants")
    .toggleClass("ProductItem__Variants_show");
  jQuery("body").toggleClass("product-varint-modal-open");
});
jQuery(document).on(
  "click",
  ".ProductItem__Variants_show .ProductItem__Sizes",
  function () {
    jQuery(this)
      .parent()
      .parent()
      .find(".ProductItem__Variants")
      .removeClass("ProductItem__Variants_show");
    jQuery("body").removeClass("product-varint-modal-open");
  }
);

jQuery(document).on("click", function (e) {
  if (
    !jQuery(e.target).closest(".ProductItem__Variants, .show_variant_plus")
      .length
  ) {
    jQuery(".ProductItem__Variants").removeClass("ProductItem__Variants_show");
    jQuery("body").removeClass("product-varint-modal-open");
  }
});

jQuery(document).ready(function () {
  $.get(
    "https://ipinfo.io",
    function (response) {
      let userCity = response.city;
      let userCountry = response.country;
      jQuery("body").attr("data-city", userCity);
      jQuery("body").attr("data-country", userCountry);
    },
    "jsonp"
  );
});

setInterval(function () {
  if (jQuery(".country-wise-amount").length > 0) {
    goalSetValue();
  }
}, 1000);

function goalSetValue() {
  setInterval(function () {
    //if(jQuery(".goal-price").length != 0) {
    const countryRegions = [
      { country: "ES", region: "IBERIAN PENINSULA", value: 90 },
      { country: "ES", region: "BALEARIC ISLANDS AND ANDORRA", value: 120 },
      { country: "ES", region: "CANARY ISLANDS", value: 180 },
      { country: "ES", region: "CEUTA AND MELILLA", value: 200 },
      { country: "PT", region: "PORTUGAL", value: 100 },
      { country: "US", region: "AMERICA", value: 400 },
    ];
    const midEurope = ["AT", "BE", "DK", "FR", "DE", "IT", "NL", "PL"];
    const midEuropeValue = 150;
    const restOfEurope = [
      "IE",
      "KR",
      "AL",
      "AM",
      "BY",
      "BA",
      "BG",
      "CZ",
      "CY",
      "HR",
      "EE",
      "FL",
      "GE",
      "GL",
      "GB",
      "GR",
      "GP",
      "GG",
      "HU",
      "BV",
      "IM",
      "DE",
      "GH",
      "IS",
      "AX",
      "FO",
      "JE",
      "LV",
      "LI",
      "LT",
      "GL",
      "MK",
      "YT",
      "Moldova",
      "Monaco",
      "Montenegro",
      "Norway",
      "RE",
      "RO",
      "SM",
      "RS",
      "SK",
      "SL",
      "SE",
      "CH",
      "SJ",
      "TR",
      "UA",
    ];
    const restOfEuropeValue = 210;
    const countriesRegion = [
      "Ireland",
      "United Kingdom",
      "Albania",
      "Armenia",
      "Belarus",
      "Bosnia and Herzegovina",
      "Bulgaria",
      "Czech Republic",
      "Cyprus",
      "Croatia",
      "Vatican",
      "Estonia",
      "Finland",
      "Georgia",
      "Gibraltar",
      "Greece",
      "Greenland",
      "Guadeloupe",
      "Guernsey",
      "Hungary",
      "Bouvet Island",
      "Isle of Man",
      "Slovakia",
      "Slovenia",
      "Iceland",
      "Åland Islands",
      "Faroe Islands",
      "Jersey",
      "Kosovo",
      "Latvia",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "North Macedonia",
      "Malta",
      "Mayotte",
      "Moldova",
      "Monaco",
      "Montenegro",
      "Norway",
      "Reunion",
      "Romania",
      "San Marino",
      "Serbia",
      "Sweden",
      "Switzerland",
      "Svalbard and Jan Mayen",
      "Turkey",
      "Ukraine",
    ];
    let userCity = jQuery("body").data("city");
    let userCountry = jQuery("body").data("country");
    let usaRegions = countryRegions.filter(
      (region) => region.country === userCountry
    );
    let goal = 0;
    if (usaRegions != undefined && usaRegions.length > 0) {
      goal = usaRegions[0].value;
    } else if (jQuery.inArray(userCountry, midEurope) !== -1) {
      goal = midEuropeValue;
    } else if (jQuery.inArray(userCountry, restOfEurope) !== -1) {
      goal = restOfEuropeValue;
    } else if (jQuery.inArray(userCountry, countriesRegion) !== -1) {
      goal = restOfEuropeValue;
    } else if (jQuery.inArray(userCity, countriesRegion) !== -1) {
      goal = restOfEuropeValue;
    } else {
      goal = 450;
    }
    //console.log("goal",goal);
    var subTotal =
      jQuery(".PriceTotal").find(".price-subtotal").attr("data-subtotal") / 100;
    var goalPrice = goal / 100; //(jQuery(".goal-price").attr("data-goal")/100);
    var remainAmount = eval(goal) - eval(subTotal);
    goal = goal * 100;
    remainAmount = remainAmount * 100;
    var normalRemainAmt = remainAmount;
    var formatPrice = customMoney(goal, window.theme.moneyFormat);
    remainAmount = customMoney(remainAmount, window.theme.moneyFormat);
    remainAmount = remainAmount.replace(/(<([^>]+)>)/gi, "");
    //console.log("remainAmount",remainAmount);
    var percentage_reached = eval(subTotal) / eval(goal);
    if (normalRemainAmt < 0) {
      var percentage_reached = 100;
      jQuery(".goal-text").hide();
      jQuery(".freeship").show();
      jQuery(".cart-footer-shipp").show();
    } else {
      jQuery(".freeship").hide();
      jQuery(".cart-footer-shipp").hide();
      jQuery(".goal-text").show();
      jQuery(".goal-price").attr("data-goal", goal);
      jQuery(".goal-price").text(remainAmount);
    }
    //console.log("formatPrice",formatPrice);
    jQuery(".country-wise-amount").html("+" + formatPrice);
  }, 500);
}
function customMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || "${{amount}}";

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }

  var value = "";

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;

    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;

    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;

    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;

    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;

    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
  }

  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value).replace(",00", "");
  } else {
    return formatString.replace(placeholderRegex, value).replace(".00", "");
  }
}

// PRODUCT GRID SLIDER
$(document).ready(function () {
    // Function to initialize the slick slider
    function initializeSlickSlider($slider){
        if (!$slider.hasClass('slick-initialized')) {
            $slider.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: true,
                prevArrow:
                  '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.8417 6.175L9.02502 10L12.8417 13.825L11.6667 15L6.66669 10L11.6667 5L12.8417 6.175Z" fill="#B5B5B5"/></svg></button>',
                nextArrow:
                  '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.15831 6.175L10.975 10L7.15831 13.825L8.33331 15L13.3333 10L8.33331 5L7.15831 6.175Z" fill="#B5B5B5"/></svg></button>',
            });
        }
    }

    jQuery(document).on("click",".collection__filter_control .CollectionToolbar__LayoutType",function(e){
      if (jQuery(window).width() <= 768) {
        // On mobile, hide the desktop image and show the slider
        jQuery('.ProductItem__Wrapper').each(function () {
            var $slider = jQuery(this).find('.product-item-slider');
            $slider.find('.product_grid_slider').slick('refresh');
        });
      }
      collectionProductBoxLayout();
    });

    function collectionProductBoxLayout(){
      if(jQuery(window).width() <= 768) {
       var layoutType = jQuery('.collection__filter_control').find('.CollectionToolbar__LayoutSwitch').find('.CollectionToolbar__LayoutType.is-active').attr('data-grid-type');
       var newCount = jQuery('.collection__filter_control').find('.CollectionToolbar__LayoutSwitch').find('.CollectionToolbar__LayoutType.is-active').attr('data-count');
      }else{
       var layoutType = jQuery('.collection__filter_control').find('.CollectionToolbar__LayoutSwitch').eq(1).find('.CollectionToolbar__LayoutType.is-active').attr('data-grid-type');
       var newCount = jQuery('.collection__filter_control').find('.CollectionToolbar__LayoutSwitch').eq(1).find('.CollectionToolbar__LayoutType.is-active').attr('data-count');
      }
      var productList = jQuery('.CollectionMain').find(".ProductList");
      if (productList) {
        var previousCount = parseInt(productList.attr("data-".concat(layoutType, "-count")));

        if (previousCount === newCount) {
          return; // Nothing has changed so we just return to avoid reflow
        }

        productList.attr(
          "data-".concat(layoutType, "-count"),
          newCount
        );
      }
        
      var settingdrawer = JSON.parse(jQuery('#sidebar-cart').attr("data-section-settings")); // Create the popover if available
      jQuery('#more-products.ProductList').find(".Grid__Cell").each(function () {
        var $item = $(this); // Wrap the current item in jQuery
        var classgridin="product_solout";
        if(jQuery(this).hasClass('product_active')){
          classgridin="product_active";
        }
        $item.attr("class", function () {
          return "Grid__Cell "+classgridin; // Retain only the 'Grid__Cell' class
        });
      
        if (layoutType === "mobile") {
          $item.addClass(`1/${newCount}--phone`);
        } else {
          var previousTabletCount = previousCount === 2 ? 2 : 3;
          var newTabletCount = newCount === 2 ? 2 : 3;
      
          //if (settingdrawer["filterPosition"] === "drawer") {
            $item.addClass(`1/${newCount}--lap-and-up`);
          //} else {
            $item.addClass(`1/${newCount}--desk`);
          //}
      
          $item.addClass(`1/${newTabletCount}--tablet-and-up`);
        }
      });
    }
  
    // Function to handle mobile-specific behavior
    window.handleMobileBehavior = function() {
        if (window.innerWidth <= 768) {
            // On mobile, hide the desktop image and show the slider
            /*$('.ProductItem__Wrapper').each(function () {
                const $desktopImage = $(this).find('.ProductItem__ImageWrapper_desktop');
                const $slider = $(this).find('.product-item-slider');

                $desktopImage.hide();
                $slider.show();

                // Initialize the slider
                initializeSlickSlider($slider.find('.product_grid_slider'));
            });*/
            var loopindex = 1;
            $('.ProductItem__Wrapper').each(function () {
                const $desktopImage = $(this).find('.ProductItem__ImageWrapper_desktop');
                const $slider = $(this).find('.product-item-slider');

                $desktopImage.hide();
                $slider.show();
                var product_url = $(this).find('.ProductItem__ImageWrapper_desktop').attr('href');
                var sliderString = '';
                if($('.CollectionInner__Products').find('.modalactive').length>0){
                  if($(this).find('.ProductItem__Image--thirdmodal').length>0){
                    var $imageCollect_modal = $(this).find('.ProductItem__Image--thirdmodal');
                    var imgdata = $imageCollect_modal.attr('src');
                    sliderString += '<div class="slider-run-time index-' + loopindex + '"><a href="' + product_url + '">';
                    sliderString += '<div data-product-link="' + product_url + '">';
                    sliderString += '<img src="' + imgdata + '"></div></a></div>';
                    loopindex++;
                  }
                  if($(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src')!="" && $(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src')!=undefined){
                    var imgdata = $(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src');
                    sliderString+='<div class="slider-run-time index-'+loopindex+'"><a href="'+product_url+'" class="">';
                    sliderString+='<div class="" aria-label="" data-product-link="'+product_url+'">';
                    sliderString+='<img class="" src="'+imgdata+'"></div></a></div>';
                    loopindex++;
                  }
                  if($(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('src')!="" && $(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('src')!=undefined){
                    var imgdata = $(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('src');
                    sliderString+='<div class="slider-run-time index-'+loopindex+'"><a href="'+product_url+'" class="">';
                    sliderString+='<div class="" aria-label="" data-product-link="'+product_url+'">';
                    sliderString+='<img class="" src="'+imgdata+'"></div></a></div>';
                    loopindex++;
                  }
                }
                else {
                  if($(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').length>0){
                    if($(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('src')!="" && $(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('src')!=undefined){
                      var imgdata = $(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('src');
                      sliderString+='<div class="slider-run-time index-'+loopindex+'"><a href="'+product_url+'" class="">';
                      sliderString+='<div class="" aria-label="" data-product-link="'+product_url+'">';
                      sliderString+='<img class="" src="'+imgdata+'"></div></a></div>';
                      loopindex++;
                    }
                    if($(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src')!="" && $(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src')!=undefined){
                      var imgdata = $(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src');
                      sliderString+='<div class="slider-run-time index-'+loopindex+'"><a href="'+product_url+'" class="">';
                      sliderString+='<div class="" aria-label="" data-product-link="'+product_url+'">';
                      sliderString+='<img class="" src="'+imgdata+'"></div></a></div>';
                      loopindex++;
                    }
                    if($('.CollectionInner__Products').find('.modalactive').length == 0){
                        if($(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src1')!="" && $(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src1')!=undefined){
                          var imgdata1 = $(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src1');
                          sliderString+='<div class="slider-run-time index-'+loopindex+'"><a href="'+product_url+'" class="">';
                          sliderString+='<div class="" aria-label="" data-product-link="'+product_url+'">';
                          sliderString+='<img class="" src="'+imgdata1+'"></div></a></div>';
                        }
                    }
                  }
                }
                if($slider.find('.product_grid_slider').hasClass('slick-initialized')){
                  $slider.find('.product_grid_slider').slick('unslick');
                }
                if(sliderString!=""){
                  jQuery(this).find('.product_grid_slider').html(sliderString);
                }
                // Initialize the slider
               
                initializeSlickSlider($slider.find('.product_grid_slider'));
            });
        }
    }

    // Hover effect for desktop
    /*$('.ProductItem__Wrapper').hover(
        function () {
            if (window.innerWidth > 768) {
                // On hover, show the slider and hide the desktop image
                $(this).find('.ProductItem__ImageWrapper_desktop').hide();
                const $slider = $(this).find('.product-item-slider');
                $slider.show();

                // Initialize the slider
                initializeSlickSlider($slider.find('.product_grid_slider'));
            }
        },
        function () {
            if (window.innerWidth > 768) {
              // On mouse leave, hide the slider and show the desktop image
              $(this).find('.product-item-slider').hide();
              $(this).find('.ProductItem__ImageWrapper_desktop').show();

              // Destroy slick if needed
              if ($(this).find('.product_grid_slider').hasClass('slick-initialized')) {
                  $(this).find('.product_grid_slider').slick('unslick');
              }
              //$(this).find('.product_grid_slider').slick('unslick');
            }
        }
    );*/

    //added new code mouse hover slider init above same code start
    // Hover effect for desktop
    /*$('.ProductItem__Wrapper').hover(
        function () {
            if (window.innerWidth > 768) {
                // On hover, show the slider and hide the desktop image
                $(this).find('.ProductItem__ImageWrapper_desktop.ProductItem__ImageWrapper').hide();
                var loopindex = 1;
                var product_url = $(this).find('.ProductItem__ImageWrapper_desktop').attr('href');
                var sliderString = '';
                if($(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').length>0){
                  if($(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src')!="" && $(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src')!=undefined){
                    var imgdata = $(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src');
                    sliderString+='<div class="slider-run-time index-'+loopindex+'"><a href="'+product_url+'" class="">';
                    sliderString+='<div class="" aria-label="" data-product-link="'+product_url+'">';
                    sliderString+='<img class="" src="'+imgdata+'"></div></a></div>';
                    loopindex++;
                  }
                  if($(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src1')!="" && $(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src1')!=undefined){
                    var imgdata1 = $(this).find('.prductitem-quickadd').find('.ProductItem__Image.show-image-collect').attr('data-img-src1');
                    sliderString+='<div class="slider-run-time index-'+loopindex+'"><a href="'+product_url+'" class="">';
                    sliderString+='<div class="" aria-label="" data-product-link="'+product_url+'">';
                    sliderString+='<img class="" src="'+imgdata1+'"></div></a></div>';
                  }
                }
                if(sliderString!=""){
                  jQuery(this).find('.product_grid_slider').html(sliderString);
                  const $slider = $(this).find('.product-item-slider');
                  if(!$slider.find('.product_grid_slider').hasClass('slick-initialized')) {
                    $slider.show();
                    initializeSlickSlider($slider.find('.product_grid_slider'));
                  }else{
                    $slider.show();
                  }
                }
            }
        },
        function () {
            if (window.innerWidth > 768) {
                // On mouse leave, hide the slider and show the desktop image
                $(this).find('.product-item-slider').hide();
                $(this).find('.ProductItem__ImageWrapper_desktop').show();

                // Destroy slick if needed
                if($(this).find('.product_grid_slider').hasClass('slick-initialized')) {
                  $(this).find('.product_grid_slider').slick('unslick');
                }
            }
        }
    );*/
    $(document).on('mouseenter', '.ProductList .prductitem-quickadd,.ProductList-- .prductitem-quickadd', function () {
        if (window.innerWidth > 768) {
            var loopindex = 1;
            var product_url = $(this).find('.ProductItem__ImageWrapper_desktop').attr('href');
            var sliderString = '';
            var $imageCollect = $(this).find('.ProductItem__Image.show-image-collect');
            if ($(this).find('.ProductItem__Image.show-image-collect').length > 0) {
                var $imageCollect = $(this).find('.ProductItem__Image.show-image-collect');

                if($('.CollectionInner__Products').find('.modalactive').length>0){
                  if($(this).find('.ProductItem__Image--thirdmodal').length>0){
                    var $imageCollect_modal = $(this).find('.ProductItem__Image--thirdmodal');
                    var imgdata = $imageCollect_modal.attr('src');
                    sliderString += '<div class="slider-run-time index-' + loopindex + '"><a href="' + product_url + '">';
                    sliderString += '<div data-product-link="' + product_url + '">';
                    sliderString += '<img src="' + imgdata + '"></div></a></div>';
                    loopindex++;
                  }
                  if ($imageCollect.attr('data-img-src')) {
                      var imgdata = $imageCollect.attr('data-img-src');
                      sliderString += '<div class="slider-run-time index-' + loopindex + '"><a href="' + product_url + '">';
                      sliderString += '<div data-product-link="' + product_url + '">';
                      sliderString += '<img src="' + imgdata + '"></div></a></div>';
                      loopindex++;
                  }
                  if($(this).find('.ProductItem__Image.show-image-collect').length>0){
                    var $imageCollect_modal = $(this).find('.ProductItem__Image.show-image-collect');
                    var imgdata = $imageCollect_modal.attr('src');
                    sliderString += '<div class="slider-run-time index-' + loopindex + '"><a href="' + product_url + '">';
                    sliderString += '<div data-product-link="' + product_url + '">';
                    sliderString += '<img src="' + imgdata + '"></div></a></div>';
                    loopindex++;
                  }
                }else{
                  if ($imageCollect.attr('data-img-src')) {
                      var imgdata = $imageCollect.attr('data-img-src');
                      sliderString += '<div class="slider-run-time index-' + loopindex + '"><a href="' + product_url + '">';
                      sliderString += '<div data-product-link="' + product_url + '">';
                      sliderString += '<img src="' + imgdata + '"></div></a></div>';
                      loopindex++;
                  }
                  if ($imageCollect.attr('data-img-src1')) {
                      var imgdata1 = $imageCollect.attr('data-img-src1');
                      sliderString += '<div class="slider-run-time index-' + loopindex + '"><a href="' + product_url + '">';
                      sliderString += '<div data-product-link="' + product_url + '">';
                      sliderString += '<img src="' + imgdata1 + '"></div></a></div>';
                  }
                  if($(this).find('.ProductItem__Image.show-image-collect').length>0){
                    var $imageCollect_modal = $(this).find('.ProductItem__Image.show-image-collect');
                    var imgdata = $imageCollect_modal.attr('src');
                    sliderString += '<div class="slider-run-time index-' + loopindex + '"><a href="' + product_url + '">';
                    sliderString += '<div data-product-link="' + product_url + '">';
                    sliderString += '<img src="' + imgdata + '"></div></a></div>';
                    loopindex++;
                  }
                }
            /*if ($imageCollect.length > 0) {
                if ($imageCollect.attr('data-img-src')) {
                    var imgdata = $imageCollect.attr('data-img-src');
                    sliderString += `<div class="slider-run-time index-${loopindex}"><a href="${product_url}"><div data-product-link="${product_url}"><img src="${imgdata}"></div></a></div>`;
                    loopindex++;
                }
    
                if ($imageCollect.attr('data-img-src1')) {
                    var imgdata1 = $imageCollect.attr('data-img-src1');
                    sliderString += `<div class="slider-run-time index-${loopindex}"><a href="${product_url}"><div data-product-link="${product_url}"><img src="${imgdata1}"></div></a></div>`;
                }
            }*/
    
            if (sliderString !== "") {
                const $sliderContainer = $(this).find('.product_grid_slider');
                $sliderContainer.html(sliderString);
    
                const $slider = $(this).find('.product-item-slider');
                $slider.show();  // Show slider container immediately
    
                // Delay hiding the main image until after Slick initializes
                if (!$sliderContainer.hasClass('slick-initialized')) {
                    $sliderContainer.on('init', function () {
                        $(this).closest('.prductitem-quickadd').find('.ProductItem__ImageWrapper_desktop').hide();
                    });
    
                    initializeSlickSlider($sliderContainer); // Initialize Slick
                } else {
                    // Hide the main image if already initialized
                    $(this).find('.ProductItem__ImageWrapper_desktop').hide();
                }
            }
          }
        }
    });

    
    $(document).on('mouseleave', '.ProductList .prductitem-quickadd,.ProductList-- .prductitem-quickadd', function () {
        if (window.innerWidth > 768) {
            // On mouse leave, hide the slider and show the desktop image
            $(this).find('.product-item-slider').hide();
            $(this).find('.ProductItem__ImageWrapper_desktop').show();
    
            // Destroy slick if needed
            if ($(this).find('.product_grid_slider').hasClass('slick-initialized')) {
                $(this).find('.product_grid_slider').slick('unslick');
            }
        }
    });
    //added new code mouse hover slider init above same code end
  
    // Initialize mobile behavior on page load
    window.handleMobileBehavior();

    // Re-check mobile behavior on window resize
    $(window).resize(window.handleMobileBehavior);

    $(document).on('change','.filter-productmodal #productmodal_checkbox',function(){
      window.handleMobileBehavior();
    })
});






$(".LookbookCarousel")
  .flickity({
    cellAlign: "left",
    contain: true,
    groupCells: 6,
    wrapAround: false,
    pageDots: false,
  })
  .on("imagesLoaded", function () {
    $(".LookbookCarousel").flickity("resize");
  });

$(".ShopTheLookCarousel")
  .flickity({
    freeScroll: true,
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
    imagesLoaded: true,
    groupCells: '80%'
  })
  .on("imagesLoaded", function () {
    $(".ShopTheLookCarousel").flickity("resize");
  });

/* START -- PRODUCT RECOMMENDATION */

$(document).ready(function () {
  $("ul.pr_tabs_titles li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.pr_tabs_titles li").removeClass("current");
    $(".pr_tab_content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });
  var sliderInterval = setInterval(function () {
    if (
      $(".product_recommendation_section").hasClass("rc_section_v1") ||
      $(".product_recommendation_section").hasClass("rc_section_v2") ||
      $(".product_recommendation_section").hasClass("rc_section_v3")
    ) {
      $(".product_grid_slider").slick("refresh");
      /*$(".product_grid__slider").slick("refresh");*/
      clearInterval(sliderInterval);
    }
  }, 1000);
});

/* END -- PRODUCT RECOMMENDATION */

/* START -- TAB COLLECTION */

$(document).ready(function () {
  $("ul.tc_tab_link li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.tc_tab_link li").removeClass("current");
    $(".tc_tab_content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });
});

/* END -- TAB COLLECTION */


jQuery(document).on("change", ".complete-look-vfirst .variant-color", function () {
  var vid = $(this).val();
  $(this).closest('.product-card').find('.product-title-icon').find('.product-title-price').find('.product-options').find('.product-icon-v3').find('.addto_upsell').attr('data-vid', vid);
  $(this).closest('.product-card').find('.product-title-icon').find('.product-icon').find('.addto_upsell').attr('data-vid', vid);
  $(this).closest('.product-card').find('.product-title-icon').find('.product-icon').find('.addto_upsell').trigger('click');
});
jQuery(document).on("change", ".complete-look-vsecond .variant-color", function () {
  var vid = $(this).val();
  $(this).closest('.product-card').find('.product-title-icon').find('.product-title-price').find('.product-options').find('.product-icon-v3').find('.addto_upsell').attr('data-vid', vid);
  $(this).closest('.product-card').find('.product-title-icon').find('.product-icon').find('.addto_upsell').attr('data-vid', vid);
  $(this).closest('.product-card').find('.product-title-icon').find('.product-icon').find('.addto_upsell').trigger('click');
});
jQuery(document).on("change", ".complete-look-vthird .variant-color", function () {
  var vid = $(this).val();
  $(this).closest('.product-card').find('.product-title-icon').find('.product-title-price').find('.product-options').find('.product-icon-v3').find('.addto_upsell').attr('data-vid', vid);
  $(this).closest('.product-card').find('.product-title-icon').find('.product-icon').find('.addto_upsell').attr('data-vid', vid);
});

jQuery(document).on("click", ".addto_upsell__completelook", function () {
  var vid = $(this).attr("data-vid");
  var pid = $(this).attr("data-pid");
  if($('.complete_look_box').hasClass('complete-look-vfirst')){
    //$(this).find('.svg_btn_v1').hide();
    //$(this).find(".add__custom_loader").show();
  }
  if($('.complete_look_box').hasClass('complete-look-vsecond')){
    //$(this).find('.svg_btn_v2').hide();
    //$(this).find(".add__custom_loader").show();
  }
  if($('.complete_look_box').hasClass('complete-look-vthird')){
    $(this).find('.svg_btn_v3').hide();
    $(this).find(".add__custom_loader").show();
  }
  data = {
    id: vid,
    quantity: 1,
  };

  jQuery.ajax({
    type: "POST",
    url: "".concat(window.routes.cartAddUrl, ".js"),
    data: data,
    dataType: "json",
    error: function () {
      
    },
    success: function () {
      if($('.complete_look_box').hasClass('complete-look-vfirst')){
        //$('.svg_btn_v1').show();
        //$(".add__custom_loader").hide();
      }
      if($('.complete_look_box').hasClass('complete-look-vsecond')){
        //$('.svg_btn_v2').show();
        //$(".add__custom_loader").hide();
      }
      if($('.complete_look_box').hasClass('complete-look-vthird')){
        $('.svg_btn_v3').show();
        $(".add__custom_loader").hide();
      }
      $('#pid_'+pid).hide();

      upsellProductHideShow();
      
      document.documentElement.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: vid,
            quantity: 1,
          },
        })
      );
    },
  });
});

setInterval(function(){
  var flag = 0;
  if($('.complete_look_box').hasClass('complete-look-vfirst')){
    flag = 1;
  }
  if($('.complete_look_box').hasClass('complete-look-vsecond')){
    flag = 1;
  }
  if($('.complete_look_box').hasClass('complete-look-vthird')){
    flag = 1;
  }
  if(flag == 1){
    //getCarts();
    upsellProductHideShow();
  }
},1000);

jQuery(document).on("click", ".CartItem__Remove_link", function () {
  var flag = 0;
  if($('.complete_look_box').hasClass('complete-look-vfirst')){
    flag = 1;
  }
  if($('.complete_look_box').hasClass('complete-look-vsecond')){
    flag = 1;
  }
  if($('.complete_look_box').hasClass('complete-look-vthird')){
    flag = 1;
  }
  if(flag == 1){
    var pid = $(this).attr('data-pid');
    jQuery('.complete_look_box').find('.popular-product').find('#pid_'+pid).show();
  }
});

function getCarts(){
  jQuery.ajax({
      url: '/cart.js',
      dataType: 'json',
      cache: false,
      type: 'GET',
      success: function (cartdata) {
        if(cartdata.items.length>0){
          upsellProductHideShow();
        }
      }
  });
}

function upsellProductHideShow(){
  var totalUpsellCount = jQuery('#collect_product_count').val();
  var totalUpsellVisibleCount = 0;
  jQuery('.popular-product').find('.product-card').each(function() {
    if(jQuery(this).css('display')=='none'){
       totalUpsellVisibleCount++;
    }
  });
  //console.log(".totalUpsellCount",totalUpsellCount,totalUpsellVisibleCount);
  if(totalUpsellCount==totalUpsellVisibleCount){
    jQuery('.complete_look_box').hide();
  }else{
    jQuery('.complete_look_box').show();
  }
}

// SEARCH RESULT TAB -- START
$(document).ready(function(){
  jQuery(document).on("click", ".search_tab_title", function () {
      var tab_id = $(this).attr('data-tab');

      $('.search_tab_title').removeClass('current');
      $('.PageLayout__Section').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
  })
})
// SEARCH RESULT TAB -- END

// FILTER -- START
// $('.collapsible--size').addClass('collapsible_active');
// $('.collapsible--colors').addClass('collapsible_active');
// $('.collapsible--color').addClass('collapsible_active');

//Filter Collection Page Load Open Some Filter Section Start
jQuery(document).ready(function () {
  var filterInter=setInterval(function(){
    if(jQuery('.collection-filters-form').find('.collapsible_active').length>0){
      jQuery('.shopify-section').find('.Collapsible').each(function(){
        var objectLoop = jQuery(this);
        if(jQuery('.shopify-section').find('#collection-filter-drawer').hasClass('filter__drawer_three') || jQuery('.shopify-section').find('#collection-filter-drawer').hasClass('filter__drawer_four')){
          if(jQuery(this).hasClass('collapsible_active')){
            setTimeout(function(){
              objectLoop.find('.Collapsible__Button').attr("aria-expanded",true);
              objectLoop.find('.Collapsible__Inner').css('overflow','visible');
              objectLoop.find('.Collapsible__Inner').css('height','auto');
              objectLoop.css('overflow','visible');
            },100);
          }
        }
      });
      clearInterval(filterInter);
    }
  },500);
});

function activeDefaultFilter(){
  if(jQuery('.collection-filters-form').find('.collapsible_active').length>0){
    jQuery('.shopify-section').find('.Collapsible').each(function(){
      var objectLoop = jQuery(this);
      if(jQuery('.shopify-section').find('#collection-filter-drawer').hasClass('filter__drawer_three') || jQuery('.shopify-section').find('#collection-filter-drawer').hasClass('filter__drawer_four')){
        if(jQuery(this).hasClass('collapsible_active')){
          setTimeout(function(){
            objectLoop.find('.Collapsible__Button').attr("aria-expanded",true);
            objectLoop.find('.Collapsible__Inner').css('overflow','visible');
            objectLoop.find('.Collapsible__Inner').css('height','auto');
            objectLoop.css('overflow','visible');
          },10);
        }
      }
    });
  }
}
let closeFlagSize=0;
let closeFlagColor=0;
function activeColorAndSize(obejectHtml){
  if(jQuery('.collection-filters-form').find('.collapsible_active').length>0){
    var objectLoop = obejectHtml;
    if(jQuery('.shopify-section').find('#collection-filter-drawer').hasClass('filter__drawer_three') || jQuery('.shopify-section').find('#collection-filter-drawer').hasClass('filter__drawer_four')){
      if((obejectHtml.hasClass('collapsible--colors') || obejectHtml.hasClass('collapsible--color')) && closeFlagColor==0){
        setTimeout(function(){
          objectLoop.find('.Collapsible__Button').attr("aria-expanded",false);
          objectLoop.find('.Collapsible__Inner').css('overflow','hidden');
          objectLoop.find('.Collapsible__Inner').css('height','0px');
          objectLoop.css('overflow','hidden');
          closeFlagColor=1;
        },10);
        var objectSize = jQuery('.collection-filters-form').find('.collapsible--size');
        if(objectSize!=undefined && closeFlagSize==0){
          setTimeout(function(){
            objectSize.find('.Collapsible__Button').attr("aria-expanded",true);
            objectSize.find('.Collapsible__Inner').css('overflow','visible');
            objectSize.find('.Collapsible__Inner').css('height','auto');
            objectSize.css('overflow','visible');
          },10);
        }
      }else if(obejectHtml.hasClass('collapsible--size') && closeFlagSize==0){
        setTimeout(function(){
          objectLoop.find('.Collapsible__Button').attr("aria-expanded",false);
          objectLoop.find('.Collapsible__Inner').css('overflow','hidden');
          objectLoop.find('.Collapsible__Inner').css('height','0px');
          objectLoop.css('overflow','hidden');
          closeFlagSize=1;
        },10);
        var objectSize = '';
        if(jQuery('.collection-filters-form').find('.collapsible--color').length>0){
          objectSize = jQuery('.collection-filters-form').find('.collapsible--color');
        }else{
          objectSize = jQuery('.collection-filters-form').find('.collapsible--colors');
        }
        if(objectSize!="" && closeFlagColor==0){
          setTimeout(function(){
            objectSize.find('.Collapsible__Button').attr("aria-expanded",true);
            objectSize.find('.Collapsible__Inner').css('overflow','visible');
            objectSize.find('.Collapsible__Inner').css('height','auto');
            objectSize.css('overflow','visible');
          },10);
        }
      }
    }
  }
}

jQuery(document).on("click",".CollectionFilters.filter__drawer_three .Collapsible__Button,.CollectionFilters.filter__drawer_four .Collapsible__Button",function(e){
  e.preventDefault();
  e.stopPropagation();
  if(closeFlagColor == 0 || closeFlagSize == 0){
    var getFilterText = jQuery(this).text();
    if(getFilterText!=undefined){
      getFilterText=getFilterText.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
      if(!jQuery(this).parent('div').hasClass('collapsible--colors') && !jQuery(this).parent('div').hasClass('collapsible--color') && !jQuery(this).parent('div').hasClass('collapsible--size')){
        activeDefaultFilter();
      }else{
          activeColorAndSize(jQuery(this).parent('div'));
      }
    }
  }
});

//Filter count set start code here
jQuery(document).on('change',".collection-filters-form .Linklist__Checkbox,.Linklist__Check",function(){
  filterActiveCount();
  filterCountData();
});
function filterActiveCount(){
  var countFilter=0;
  countFilter+=parseInt(jQuery('.collection-filters-form .Linklist__Checkbox:checked').length);
  countFilter+=parseInt(jQuery('.collection-filters-form .Linklist__Check:checked').length);
  // console.log("countFilter",countFilter);
  if(parseInt(countFilter)>0){
    if(jQuery('.ButtonGroup').find('.ButtonGroup__Item.ButtonGroup__Item--expand').find('.Text--subdued').length!=0){
      jQuery('.ButtonGroup').find('.ButtonGroup__Item.ButtonGroup__Item--expand').find('.Text--subdued').show();
      jQuery('.ButtonGroup').find('.ButtonGroup__Item.ButtonGroup__Item--expand').find('.Text--subdued').text('('+countFilter+')');
    }else{
      jQuery('.ButtonGroup').find('.ButtonGroup__Item.ButtonGroup__Item--expand').append('<span class="Text--subdued">('+countFilter+')</span>');
    }
    jQuery('.CollectionFilters__ClearButton').show();
  }else{
    jQuery('.ButtonGroup').find('.ButtonGroup__Item.ButtonGroup__Item--expand').find('.Text--subdued').hide();
    jQuery('.CollectionFilters__ClearButton').hide();
  }
}
//Filter count set end code here

//$('.filter_collapsible').addClass('Collapsible--autoExpand');

// SWITCH
$(document).ready(function () {
  if ($('#switch_checkbox').is(':checked')) {
    $('.CollectionInner__Products').addClass('soldout_hide');
  }
  $('#switch_checkbox').on('change', function () {
    if ($(this).is(':checked')) {
      $('.CollectionInner__Products').addClass('soldout_hide');
    } else {
      $('.CollectionInner__Products').removeClass('soldout_hide');
    }
    filterCountData();
  });
});


// FILTER -- END

/******************* PRODUCT DETAILS PAGE VARIANT HOVER SWATCH START JS ********************/
jQuery(document).ready(function(){
    //Color swatch
    jQuery(document).on("mouseover",".ProductForm__Variants .Color__Link", function () {
      jQuery(".ProductForm__Variants .Color__Link div").removeClass('active');
      jQuery(this).find('div').addClass('active');
    });
    jQuery(document).on("mouseout",".ProductForm__Variants .Color__Link", function () {
      jQuery(".ProductForm__Variants .Color__Link div").removeClass('active');
      jQuery(".ProductForm__Variants .Color__Link.Active").find('div').addClass('active');
    });
    
    //Size swatch
    jQuery(document).on("mouseover",".ProductForm__Variants .SizeSwatchList li", function () {
      jQuery(".ProductForm__Variants .SizeSwatchList .SizeSwatch").removeClass('active');
      jQuery(this).find('.SizeSwatch').addClass('active');
    });
    jQuery(document).on("mouseout",".ProductForm__Variants .SizeSwatchList", function () {
       jQuery(".ProductForm__Variants .SizeSwatchList li label").removeClass('active');
       jQuery(".ProductForm__Variants .SizeSwatch__Radio:checked").parent().find('label').addClass('active');
    });
});
/******************* PRODUCT DETAILS PAGE HOVER SWATCH END JS ********************/



document.addEventListener("DOMContentLoaded", function () {
  var carouselElement = document.querySelector(".ShopTheLook");
  var flkty = Flickity.data(carouselElement);

  if (!flkty) return;

  var progressBar = document.querySelector(".progress");
  var modalButtons = document.querySelectorAll('[data-action="open-modal"]');
  var DRAG_THRESHOLD = 5;
  var startX = 0;
  var startY = 0;
  var dragging = false;

  // ⏳ Barra de progreso del carrusel
  flkty.on("scroll", function (progress) {
    progress = Math.max(0, Math.min(1, progress));
    progressBar.style.width = progress * 100 + "%";
  });

  // 💡 Control preciso de clicks tras drag
  modalButtons.forEach(function (button) {
    button.addEventListener("pointerdown", function (e) {
      startX = e.clientX;
      startY = e.clientY;
      dragging = false;
    });

    button.addEventListener("pointermove", function (e) {
      const dx = Math.abs(e.clientX - startX);
      const dy = Math.abs(e.clientY - startY);
      if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
        dragging = true;
      }
    });

    button.addEventListener("pointerup", function (e) {
      if (!dragging) {
        e.preventDefault();
        e.stopImmediatePropagation();
        button.click(); // Forzar apertura inmediata del modal
      }
    });

    button.addEventListener("click", function (e) {
      if (dragging) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
  });
});


// :::::::::::::::::: Collection fitler [Development] ::::: START :::::

$(document).ready(function () {
    $("#productmodal_checkbox").on("change", function () {
        if ($(this).is(":checked")) {
            $(".ProductList").addClass("modalactive");
        } else {
            $(".ProductList").removeClass("modalactive");
        }
    });
});

jQuery(document).ready(function(){
  if(jQuery('.CollectionToolbar__Item.CollectionToolbar__Item--color').length>0){
      // Append content for Length and Color filters after their respective buttons
      const lengthButton = jQuery('.filter_group.CollectionToolbar__Group .CollectionToolbar__Item--size');
      const colorButton = jQuery('.filter_group.CollectionToolbar__Group .CollectionToolbar__Item--color');
      //const typeButton = jQuery('.filter_group.CollectionToolbar__Group .CollectionToolbar__Item--type');
      const drawer = document.querySelector("#dbtfyCollectionFilter");
      const lengthContent = jQuery('.collection-filters-form .collapsible--size .Collapsible__Inner').prop('outerHTML');
      if(jQuery(".collection-filters-form").find(".collapsible--color").length>0){
        var colorContent = jQuery(".collection-filters-form").find(".collapsible--color .Collapsible__Inner").prop('outerHTML');
      }else{
        var colorContent = jQuery(".collection-filters-form .collapsible--colors .Collapsible__Inner").prop('outerHTML');
      }
      //const typeContent = jQuery(".collection-filters-form .collapsible--item .Collapsible__Inner").prop('outerHTML');
      //console.log("colorContent",colorContent);
      if(lengthButton.find('.filter-button-size').length>0){
        lengthButton.find('.filter-button-size').after(lengthContent);
        lengthButton.find('.Collapsible__Inner').hide();
      }

      if(colorButton.find('.filter-button-color').length>0){
        colorButton.find('.filter-button-color').after(colorContent);
        colorButton.find('.Collapsible__Inner').hide();
      }

      /* if(typeButton.find('.filter-button-type').length>0){
        typeButton.find('.filter-button-type').after(typeContent);
        typeButton.find('.Collapsible__Inner').hide();
      } */

      // Toggle functionality
      function toggleFilter(button, content) {
        if (content.is(':visible')) {
          content.slideUp();
          button.removeClass('active');
        } else {
          jQuery('.filter_group.CollectionToolbar__Group .Collapsible__Inner').slideUp();
          jQuery('.filter-button-size, .filter-button-color').removeClass('active');
          //, .filter-button-type
          content.slideDown();
          button.addClass('active');
        }
      }

      jQuery('.filter-button-size').on('click', function(e) {
        e.stopPropagation();
        toggleFilter(jQuery(this), lengthButton.find('.Collapsible__Inner'));
      });

      jQuery('.filter-button-color').on('click', function(e) {
        e.stopPropagation();
        toggleFilter(jQuery(this), colorButton.find('.Collapsible__Inner'));
      });

      /* jQuery('.filter-button-type').on('click', function(e) {
        e.stopPropagation();
        toggleFilter(jQuery(this), typeButton.find('.Collapsible__Inner'));
      }); */
   }
  
});
// :::::::::::::::::: Collection fitler [Development] ::::: END :::::

/*************************** PRODUCT DETAILS PAGE SIZE BUTTON CLICK EVENT START *****************************/

jQuery(document).on("click", ".size-button-section .size-buttons", function (e) {
    var headerHeight = jQuery('.shopify-section--header').find('.Header').height();
    headerHeight = parseInt(headerHeight);
    jQuery('html,body').animate({
        scrollTop: (jQuery('.ProductMeta__Title').offset().top - headerHeight)
    }, 400);
    e.preventDefault();
});


// jQuery('body').addClass('pdp-button-size-v1');
// jQuery('body').addClass('pdp-button-size-v2');

jQuery(window).on("scroll", function () {
  if(jQuery(".ProductForm__BuyButtons").find('.ProductForm__AddToCart').length>0){
    const target = jQuery(".ProductForm__BuyButtons").find('.ProductForm__AddToCart');
    const hideshowSize = jQuery(".size-button-section");
    const windowHeight = jQuery(window).height();
    const scrollTop = jQuery(window).scrollTop();
    const elementOffset = target.offset().top;

    // if (jQuery('body').hasClass('pdp-button-size-v1')) {
        if (scrollTop + windowHeight > elementOffset && scrollTop < elementOffset + target.height()) {
            hideshowSize.hide();
        } else {
            hideshowSize.show();
        }
    // }
    //  else if (jQuery('body').hasClass('pdp-button-size-v2')) {
    //     if (scrollTop + windowHeight > elementOffset) {
    //         hideshowSize.hide();
    //     } else {
    //         hideshowSize.show();
    //     }
    // }
  }
});

/*************************** PRODUCT DETAILS PAGE SIZE BUTTON CLICK EVENT END *******************************/

/*************************** CALCULATE HEIGHT SAMPLE BUTTON START *******************************/
$(document).ready(function () {
    function ajustarAltura() {
        if ($(window).width() <= 1007) return; // Solo ejecuta si la pantalla es mayor a 1007px

        const $div = $(".Product--Samples");
        if ($div.length === 0) return;

        const headerHeight = $("header").outerHeight(); // Obtiene la altura total del header (o la de tu elemento específico)
        const viewportHeight = $(window).height(); // Altura del viewport

        // Calcula la altura disponible, descontando la altura del header y los márgenes
        const availableHeight = viewportHeight - headerHeight - (26 * 2); // Descontamos 26px para cada margen (top y bottom)

        // Aplica la altura disponible como min-height
        $(".Product__InfoWrapper > .Product__Info > .Container > form .form_content")
            .css("min-height", availableHeight + "px");
    }

    // Ejecutar al cargar la página y al cambiar el tamaño de la ventana
    $(window).on("load resize", ajustarAltura);

    // Ejecutar la función de ajuste de altura una vez al inicio
    ajustarAltura();
});

/*************************** CALCULATE HEIGHT SAMPLE BUTTON END *******************************/

// :::::::::::::::::: (EME Team) Desktop quick view ::::: START :::::

jQuery(document).ready(function ($) {
  jQuery(document).on("click", ".quickview-btn, .Color__Link__qv", function () {
    let productHandle = jQuery(this).data("handle");
    let productId = jQuery(this).data("pid");
     //$("#quickview-modal").css("display", "none");

     // Select slider elements
    var $slideshow = jQuery('.Product----Slideshow');
    var $thumbnail = jQuery('.Product----Thunmbnail');

    // **Check if Slick is already initialized, then destroy it**
    if ($slideshow.hasClass('slick-initialized')) {
        $slideshow.slick('unslick');
    }
    if ($thumbnail.hasClass('slick-initialized')) {
        $thumbnail.slick('unslick');
    }

    jQuery.ajax({
      url: `/products/${productHandle}/?sections=quick-product-view`, // Fetch full product page
      method: "GET",
      success: function (data) {
        var newContentHTML = data['quick-product-view'];

        // Show Quickview Modal
        jQuery("#quickview-modal").html(newContentHTML);
        //$("#quickview-modal").css("display", "flex");
        jQuery('body').addClass('qvpopup-open');
        jQuery("#quickview-modal").addClass('quic-isactive');

        jQuery('.Product----Slideshow').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: false,
                asNavFor: '.Product----Thunmbnail'
            });
        jQuery('.Product----Slideshow').slick('setPosition');
        jQuery('.Product----Thunmbnail').slick({
              slidesToShow: 6,
              slidesToScroll: 1,
              vertical:true,
              asNavFor: '.Product----Slideshow',
              dots: false,
              focusOnSelect: true,
              verticalSwiping:true,
              responsive: [
                {
                    breakpoint: 1279,
                    settings: {
                       slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                      vertical: false,
                      slidesToShow: 5
                    }
                },
                {
                  breakpoint: 768,
                  settings: {
                    vertical: false,
                    slidesToShow: 5,
                  }
                },
                {
                  breakpoint: 580,
                  settings: {
                    vertical: false,
                    slidesToShow: 4,
                  }
                },
                {
                  breakpoint: 380,
                  settings: {
                    vertical: false,
                    slidesToShow: 4,
                  }
                }
              ]
          });  
        

      },
      error: function () {
        console.error("Error: Failed to load product page.");
      },
    });
  });

  //$(".close-modal").on("click", function () {
  jQuery(document).on("click", ".close-modal", function () {
    let productId = jQuery(this).data("pid");
    jQuery('body').removeClass('qvpopup-open');
    jQuery("#quickview-modal").removeClass('quic-isactive');
    //$("#quickview-modal").css("display", "none");
  });
  
  jQuery(document).on("click", ".ProductForm__AddToCart_qv", function () {
    let variantId = jQuery('input[name="qv-option-0"]:checked').val();
    let qty = jQuery('#quickview-modal').find('.QuantitySelector__CurrentQuantity__qv').val();

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { id: variantId, quantity: qty },
      dataType: "json",
      success: function () {
        setTimeout(function () {
          jQuery('body').removeClass('qvpopup-open');
          jQuery("#quickview-modal").removeClass('quic-isactive');
        }, 500);

       document.documentElement.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: variantId,
              quantity: qty,
            },
          })
        );
      },
      error: function () {
        alert("Error adding product to cart.");
      }
    });
  });

  jQuery(document).on("click", ".QuantitySelector__Button", function () {
    var $input = jQuery(this).siblings(".QuantitySelector__CurrentQuantity");
    var currentVal = parseInt($input.val()) || 1;

    if ($(this).data("action") === "increase-quantity") {
        $input.val(currentVal + 1);
    } else if ($(this).data("action") === "decrease-quantity" && currentVal > 1) {
        $input.val(currentVal - 1);
    }
});

});

// :::::::::::::::::: (EME Team) Desktop quick view ::::: END :::::

/********************** COLLECTION PAGE VISIT AND AFTER CLICK PRODUCT TO SET PREVIOUS AND NEXT PRODUCT LINK DETAILS PAGE JS START ************************/
//collection page visit to set previous and next link
$(document).ready(function () {
    if ($('.template-collection').find('.CollectionInner__Products').length > 0) {
        localStorage.setItem("prevProduct", '');
        localStorage.setItem("nextProduct", '');
        localStorage.setItem("collectionName", '');
        localStorage.setItem("currentProduct", '');

        let productLinks = $('.CollectionInner__Products').find(".prductitem-quickadd a.ProductItem__ImageWrapper_desktop");
        let productArray = [];
        
        // Store all product URLs in an array
        productLinks.each(function () {
            productArray.push($(this).attr("href"));
        });
        //console.log("productArray",productArray);
        // Save product URLs in localStorage
        localStorage.setItem("productList", JSON.stringify(productArray));
        let prevProduct = window.location.href;
      localStorage.setItem("prevProduct", prevProduct);
      let collectionName = '';
      if (jQuery('.section-collection-scroll').find('.SectionHeader__Heading').length > 0) {
          collectionName = jQuery('.section-collection-scroll').find('.SectionHeader__Heading').text();
      }
      // console.log("collectionName",collectionName);
      localStorage.setItem("collectionName", collectionName);
        // Detect product click and save previous & next product links
        jQuery(document).on('click', '.CollectionInner__Products .prductitem-quickadd a,.ProductListWrapper .prductitem-quickadd a,.ProductListWrapper .ProductItem__Container .ProductItem__Title a', function () {
            let clickedProduct = $(this).attr("href");
            // console.log("clickedProduct",clickedProduct);
            let storedProducts = JSON.parse(localStorage.getItem("productList")) || [];

            let productIndex = storedProducts.indexOf(clickedProduct);
            
            let nextProduct = productIndex < storedProducts.length - 1 ? storedProducts[productIndex + 1] : null;
            

            
            localStorage.setItem("nextProduct", nextProduct);
            
        });
    } else if (jQuery('body').hasClass('template-index')) {
        localStorage.setItem("prevProduct", '');
        localStorage.setItem("nextProduct", '');
        localStorage.setItem("collectionName", '');
        localStorage.setItem("currentProduct", '');
    }
});

// Product details page: Get previous and next links
$(document).ready(function () {
    if (jQuery('.template-product').find('.nextprev-wrap').length > 0) {
        let productArray = JSON.parse(localStorage.getItem("productList")) || [];
        let currentProduct = localStorage.getItem("currentProduct");
        let prevProduct = localStorage.getItem("prevProduct");
      
        let nextProduct = localStorage.getItem("nextProduct");
        let collectName = localStorage.getItem("collectionName");
        console.log("prevProduct",prevProduct,collectName);
        let productIndex = productArray.indexOf(currentProduct);
        let newNextProduct = productIndex < productArray.length - 1 ? productArray[productIndex + 1] : null;

        let objlinkhtml = jQuery('.template-product').find('.nextprev-product-one');
      
        let objlinkhtml1 = jQuery('.template-product').find('.nextprev-product-two');

        let flagnav = 0;

        // Set Previous Product Link
        if (prevProduct) {
            if (collectName !== "") {
                objlinkhtml.find(".prev-product .collection-title").text(collectName);
              objlinkhtml1.find(".prev-product .collection-title").text(collectName);
            } else {
                let cleanUrl = prevProduct.split('?')[0];
                let lastSegment = cleanUrl.split('/').filter(Boolean).pop();

                if (lastSegment) {
                    let upperCaseName = decodeURIComponent(lastSegment).replace(/-/g, ' ').toUpperCase();
                    objlinkhtml.find(".prev-product .collection-title").text(upperCaseName);
                  objlinkhtml1.find(".prev-product .collection-title").text(upperCaseName);
                }
            }
            objlinkhtml.find(".prev-product").attr("href", prevProduct);
            objlinkhtml1.find(".prev-product").attr("href", prevProduct);
        } else {
            //objlinkhtml.find(".prev-product").hide();
            flagnav = 1;
        }

        // Set Next Product Link
        if (nextProduct) {
            objlinkhtml.find(".next-product").attr("href", nextProduct);
          objlinkhtml1.find(".next-product").attr("href", nextProduct);
        } else {
            //objlinkhtml.find(".next-product").hide();
            flagnav = 1;
        }

        if (flagnav === 0) {
            jQuery('.template-product').find('.nextprev-wrap').addClass('active-wrap');
        }

        // Update current product and next product on click
        jQuery(document).on("click", ".next-product", function () {
            localStorage.setItem("currentProduct", nextProduct);
            let nextIndex = productArray.indexOf(nextProduct);
            let newNextProduct = nextIndex < productArray.length - 1 ? productArray[nextIndex + 1] : null;
            localStorage.setItem("nextProduct", newNextProduct);
        });
    }
});



/********************** COLLECTION PAGE VISIT AND AFTER CLICK PRODUCT TO SET PREVIOUS AND NEXT PRODUCT LINK DETAILS PAGE JS END ************************/

/********************** PRODUCT DETAILS PAGE FOR SLIDER INIT FOR RECOMMEND PRODUCT FOR ADD CLASS CONVERT JS START *******************/
/*jQuery(document).ready(function(){
  var sliderRcId = setInterval(function(){
    if(jQuery('.ProductRecommendations_tabing').find('.recommend-product-pdp.slider-active').length>0){
      $(".recommend-product-pdp.slider-active").flickity({
        "prevNextButtons": true,
        "pageDots": false,
        "wrapAround": false,
        "contain": true,
        "cellAlign": "left",
        "watchCSS": true,
        "dragThreshold": 8,
        "groupCells": true,
        "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
      });
      clearInterval(sliderRcId);
    }
  },1000);
});*/
jQuery(document).ready(function(){
  var slideId = setInterval(function () {
    var $slider = jQuery('.ProductRecommendations_tabing .recommend-product-pdp.slider-active');
    if ($slider.length > 0 && !$slider.hasClass('flickity-enabled')) {
      /*$slider.flickity({
        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        contain: true
      });*/
      $slider.flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        groupCells: 1 // ensures 1 slide per scroll
      });

      clearInterval(slideId);
    }
  }, 100);
});
/********************** PRODUCT DETAILS PAGE FOR SLIDER INIT FOR RECOMMEND PRODUCT FOR ADD CLASS CONVERT JS END *******************/

// SELECTED FILTER -- START
$(document).ready(function () {
  function updateSelectedFilters() {
    const $selectedContainer = $('.selected-filters');
    $selectedContainer.empty();
    let hasSelected = false;

    $("#collection-filters-drawer-form").find('input[type="checkbox"]:checked').each(function () {
      const $checkbox = $(this);
      const filterId = $checkbox.attr('id');
      let filterLabel = '';

      const $label = $('label[for="' + filterId + '"]');
      if ($label.length) {
        filterLabel = $label.text().trim();
      } else {
        filterLabel = $checkbox.closest('label').text().trim();
      }
      filterLabel = $checkbox.parent().find('label').find('div').text().trim();
      if(filterLabel == ''){
        filterLabel = $checkbox.parent().find('label').text().trim();
      }
      
      if (filterLabel !== '') {
        const filterTag = $(`
          <span class="selected-filter-tag" data-id="${filterId}">
            ${filterLabel} <span class="remove-filter"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="M4.08203 4.58594L9.91536 10.4193M4.08203 10.4193L9.91536 4.58594" stroke="black" stroke-opacity="0.6" stroke-linecap="round" stroke-linejoin="round"/></path></svg></span>
          </span>
        `);
        $selectedContainer.append(filterTag);
        hasSelected = true;
      }
    });

    $('.clear-all-filters').show();
    $('.selected-filters-wrapper').toggle(hasSelected);
  }

  $(document).on('change', 'input[type="checkbox"]', function () {
    updateSelectedFilters();
  });

  $(document).on('click', '.remove-filter', function () {
    const filterId = $(this).closest('.selected-filter-tag').data('id');
    $('#' + filterId).prop('checked', false).trigger('change');

    $('#' + filterId).closest('form').submit();
  });

  $(document).on('click', '.clear-all-filters', function () {
    $('.CollectionFilters__ClearButton').trigger('click');
    
    $('.selected-filters').empty();
    $('.selected-filters-wrapper').hide();
    $('.CollectionFilters__ClearButton').hide();
    $('.ButtonGroup').find('.ButtonGroup__Item.ButtonGroup__Item--expand').find('.Text--subdued').hide();
    
  });

  $(document).on('click', '.CollectionFilters__ClearButton', function () {
    updateSelectedFilters();
    $('.selected-filters').empty();
    $('.selected-filters-wrapper').hide();
    $('.CollectionFilters__ClearButton').hide();
    $('.ButtonGroup').find('.ButtonGroup__Item.ButtonGroup__Item--expand').find('.Text--subdued').hide();
  });

  document.addEventListener('shopify:section:load', function () {
    updateSelectedFilters();
  });

  setTimeout(updateSelectedFilters(), 300);
});
// SELECTED FILTER -- END
/*jQuery(document).ready(function(){
  $('.product__deskslideshow').addClass('convert_desktopslider');
  $('.Product--Main').addClass('product-gallery-vtwo');
  if (window.innerWidth >= 1007 && (jQuery('.product-gallery-vthree').length>0 || jQuery('.product-gallery-vfour').length>0 || jQuery('.product-gallery-vtwo').length>0)) {
    if(jQuery('.product-gallery-vtwo').length==0){
      jQuery('.product__deskslideshow.convert_desktopslider').find('.carousel-main').removeAttr('data-flickity');
      jQuery('.product__deskslideshow.convert_desktopslider').find('.carousel-nav').removeAttr('data-flickity');
      jQuery('.product__deskslideshow.convert_desktopslider').find('.carousel-main').flickity('destroy');
      jQuery('.product__deskslideshow.convert_desktopslider').find('.carousel-nav').flickity('destroy');
    }
  }
});*/
$(window).bind('load',function () {
  function initDesktopSlider() {
    if (window.innerWidth >= 1007 && (jQuery('.product-gallery-vthree').length>0 || jQuery('.product-gallery-vfour').length>0 || jQuery('.product-gallery-vtwo').length>0)) {
      if(jQuery('.convert_desktopslider').find('.carousel-main').length>0){
        var gallerySection = document.querySelector('.product-gallery-vthree');
        if(gallerySection==null){
          gallerySection = document.querySelector('.product-gallery-vfour');
          if(gallerySection==null){
            gallerySection = document.querySelector('.product-gallery-vtwo');
          }
        }
        const mainCarousel = gallerySection.querySelector('.carousel-main');
        const navCarousel = gallerySection.querySelector('.carousel-nav');
        if(document.querySelector('.product-gallery-vfour')!=null){
          const flktyMain = new Flickity(mainCarousel, {
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            cellAlign: 'left',
            draggable: true,
            cssWatch:true,
            freeScroll: true
          });
  
          // Init nav carousel (thumbnail slider)
          const flktyNav = new Flickity(navCarousel, {
            asNavFor: mainCarousel,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            cssWatch:true,
            cellAlign: 'left',
            freeScroll: true, // allows dragging thumbnails freely
            draggable: true   // ensures horizontal scrolling
          });
        }else{
          const flktyMain = new Flickity(mainCarousel, {
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            cellAlign: 'left',
            draggable: true,
            cssWatch:true,
            freeScroll: true
          });
  
          // Init nav carousel (thumbnail slider)
          const flktyNav = new Flickity(navCarousel, {
            asNavFor: mainCarousel,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            cssWatch:true,
            cellAlign: 'left',
            freeScroll: true, // allows dragging thumbnails freely
            draggable: true   // ensures horizontal scrolling
          });
        }
      }
    }
  }
  setTimeout(function(){
    initDesktopSlider();
  },100);
});
